import { g as getFreshSideObject } from './getFreshSideObject-CFutYILm.js';

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

export { mergePaddingObject as m };
//# sourceMappingURL=mergePaddingObject-B3ulvIFT.js.map
